import React from 'react';

import Tooltip from '../Tooltip';
import LocationInfo from '../LocationInfo';
import Disclaimer from '../Disclaimer';

export default ({ statusDetail }) => (
  <article className="has-border-grey nbn-infobox__article content-area-white clearfix">
    <div className="one_half nbn-infobox__column">
      <p className="nbn-infobox__column__text">Fibre is already available in this area. For specific information on how to connect, contact your carrier.</p>
      <div className="nbn-def-list">
        <dl className="has-margin-bottom-xsmall clearfix">
          <dt>Carrier <Tooltip icon="icon-info-solid" iconcolor="nbn-text-light-blue" position="top"><p className="text-x-small">This carrier delivers the fibre network to this area.</p></Tooltip></dt>
          <dd>{ statusDetail.carrier ? statusDetail.carrier : 'Not Available' }</dd>
        </dl>
        <dl className="clearfix">
          <dt>Rollout Type <Tooltip icon="icon-info-solid" iconcolor="nbn-text-light-blue" position="top"><p className="text-x-small">The NBN technology and rollout type of rollout used in this rollout area</p></Tooltip>
            <img src="https://dvh1deh6tagwk.cloudfront.net/finder-au/wp-uploads/2020/07/powered-by-nbn-lozenge.png" className="luna-image" alt="powered by nbn" />
          </dt>
          <dd>{ statusDetail.service_type_name }</dd>
        </dl>
        { statusDetail.recent_active
          ? <p className="text-center has-margin-bottom-xsmall line-height-medium"><small className="text-xxx-small fin-text-red">This area recently went active so we can't guarantee that a provider could connect you immediately.</small></p>
          : null }
      </div>
      { statusDetail.last_updated
        ? <small className="fin-text-grey text-xxx-small text-center hide-mobile">Accurate as at: { statusDetail.last_updated }</small>
        : null
      }
    </div>
    <div className="one_half nbn-infobox__column">
      <LocationInfo statusDetail={statusDetail} />
      <a href='https://www.finder.com.au/adequately-served-areas' className="btn btn-success weight-normal btn--fluid has-margin-bottom-xsmall">More Info</a>
    </div>
    <Disclaimer />
  </article>
);
